function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.7776 31.1938V1.79888C33.7776 0.7995 32.9876 0 32 0C31.0124 0 30.2224 0.7995 30.2224 1.79888V31.1938C26.101 32.0333 22.9803 35.7243 22.9803 40.1482C22.9803 44.5721 26.101 48.2632 30.2224 49.1026V62.1878C30.2224 63.1872 31.0124 63.9867 32 63.9867C32.9876 63.9867 33.7776 63.1872 33.7776 62.1878V49.1026C37.899 48.2632 41.0197 44.5721 41.0197 40.1482C41.0197 35.7377 37.9122 32.0333 33.7776 31.1938ZM32 45.6781C28.9847 45.6781 26.5355 43.1997 26.5355 40.1482C26.5355 37.0968 28.9847 34.6184 32 34.6184C35.0154 34.6184 37.4645 37.0968 37.4645 40.1482C37.4645 43.1997 35.0154 45.6781 32 45.6781Z",
  fill: "#373F51"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.7973 16.1099V1.79888C10.7973 0.7995 10.0073 0 9.01971 0C8.03215 0 7.2421 0.7995 7.2421 1.79888V16.1099C3.12069 16.9494 0 20.6404 0 25.0643C0 29.4882 3.12069 33.1793 7.2421 34.0187V62.1878C7.2421 63.1872 8.03215 63.9867 9.01971 63.9867C10.0073 63.9867 10.7973 63.1872 10.7973 62.1878V34.0054C14.9187 33.1659 18.0394 29.4749 18.0394 25.051C18.0394 20.6271 14.9187 16.9494 10.7973 16.1099ZM9.01971 30.5942C6.00436 30.5942 3.55521 28.1158 3.55521 25.0643C3.55521 22.0129 6.00436 19.5345 9.01971 19.5345C12.0351 19.5345 14.4842 22.0129 14.4842 25.0643C14.4842 28.1158 12.0219 30.5942 9.01971 30.5942Z",
  fill: "#373F51"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M56.7579 16.1099V1.79888C56.7579 0.7995 55.9679 0 54.9803 0C53.9927 0 53.2027 0.7995 53.2027 1.79888V16.1099C49.0813 16.9494 45.9606 20.6404 45.9606 25.0643C45.9606 29.4882 49.0813 33.1793 53.2027 34.0187V62.2011C53.2027 63.2005 53.9927 64 54.9803 64C55.9679 64 56.7579 63.2005 56.7579 62.2011V34.0054C60.8793 33.1659 64 29.4749 64 25.051C64 20.6271 60.8925 16.9494 56.7579 16.1099ZM54.9803 30.5942C51.9649 30.5942 49.5158 28.1158 49.5158 25.0643C49.5158 22.0129 51.9649 19.5345 54.9803 19.5345C57.9956 19.5345 60.4448 22.0129 60.4448 25.0643C60.4448 28.1158 57.9956 30.5942 54.9803 30.5942Z",
  fill: "#373F51"
});

var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings.6fb4810d.svg";
export { ForwardRef as ReactComponent };